<div class="locations-wrapper">
	@if (editable) {
		<span class="select-label location-label" [class.error]="isRequiredAndInvalid">
			{{ isRequired ? ('location' | translate) + ' *' : ('location' | translate) }}
		</span>
	}
	<div
		class="visibility-hidden"
		[matMenuTriggerFor]="locationsList"
		[matMenuTriggerRestoreFocus]="false"
		#menuTrigger="matMenuTrigger"
	></div>
	@if (displayedLocations()?.length) {
		<au-expandable-tags
			[tags]="displayedLocations()"
			[initSize]="showAmount"
			minWidth="initial"
			class="location-tags"
		>
			@if (editable) {
				<button
					mat-mini-fab
					class="surface-fab"
					[matTooltip]="matTooltipText"
					(click)="openLocationsList($event)"
				>
					<mat-icon>edit</mat-icon>
				</button>
			}
		</au-expandable-tags>
	}

	@if (editable && !locationsInputList()?.length) {
		@if (!locationsInputList()?.length) {
			<span
				matRipple
				class="choose-location-btn cursor-pointer"
				(click)="openLocationsList($event)"
				[class.error]="isRequiredAndInvalid"
			>
				{{ 'choose' | translate }}
				<mat-icon>arrow_drop_down</mat-icon>
			</span>
		}
	}
</div>

<mat-menu #locationsList class="locations-list-container" xPosition="after">
	<div
		class="locations-list nice-scroll colored-scroll-track visible-scroll"
		(click)="$event.stopPropagation()"
	>
		@if (menuTrigger.menuOpen) {
			<au-locations-tree-selector
				(locationsChanged)="treeViewStateChanged($event)"
				[locationInputList]="locationsInputList()"
				[disableMultipleSelect]="disableMultipleSelect"
				[disableNestedSelection]="disableNestedSelection()"
				[allowDeselectForSingleSelect]="allowDeselectForSingleSelect()"
			/>
		}
	</div>
</mat-menu>
